const Background = () => {
  return <div className="background-container" data-testid="background"></div>;
};

export default Background;
